import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}(); // FHT Swagger jQuery client V2

/* eslint-disable */


import { BaseApi } from "./api";

var FollowApiApi =
/** @class */
function (_super) {
  __extends(FollowApiApi, _super);

  function FollowApiApi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.followApiCompanyFollowAsync = function (p) {
      var localVarPath = '/api/follows/_companyFollow';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.followApiCompanyUnFollowAsync = function (p) {
      var localVarPath = '/api/follows/_companyUnfollow';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.followApiGetFollowCompanyIdsAsync = function (p) {
      var localVarPath = '/api/follows/_getFollowCompanyIds';

      _this.r(p, ["model"]);

      var bodyDict = p["model"];
      var _p = p;
      delete _p["model"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.followApiGetFolloweeIdsAsync = function (p) {
      var localVarPath = '/api/follows/getFolloweeIds';

      _this.r(p, ["model"]);

      var bodyDict = p["model"];
      var _p = p;
      delete _p["model"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.followApiGetFolloweesByFollowerIdAsync = function (p) {
      var localVarPath = '/api/follows/myfollowuser';

      _this.r(p, []);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.followApiGetMyFollowCompanyAsync = function (p) {
      var localVarPath = '/api/follows/myfollowCompany';

      _this.r(p, []);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.followApiGetUserFollowersByFolloweeIdAsync = function (p) {
      var localVarPath = '/api/follows/followme';

      _this.r(p, []);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.followApiUserFollowAsync = function (p) {
      var localVarPath = '/api/follows/_userFollow';

      _this.r(p, ["followeeId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.followApiUserUnFollowAsync = function (p) {
      var localVarPath = '/api/follows/_userUnfollow';

      _this.r(p, ["followeeId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    return _this;
  }

  return FollowApiApi;
}(BaseApi);

export { FollowApiApi };